import * as moment from "moment";
import { ModelAssumptionsUtil } from "src/app/core/v2/state/valuation-process/core/income/model-assumptions-util";
import { CostAssessmentRecordRow, DepreciatedRecordRow } from "../../types";
import { RecordOptions } from "./calculation";
import { normalizeRecords } from "./normalize";

export interface ThreeWyasMultiOptions {
  kind: 'three-ways-multi',
  physicalDepreciationFactor: number,
  functionalDepreciation: number,
  economicDepreciation: number
}
export function threeWaysMultiMethod(
  records: CostAssessmentRecordRow[],
  recordOptions: RecordOptions,
  options: ThreeWyasMultiOptions
) {
  const {
    physicalDepreciationFactor,
    functionalDepreciation,
    economicDepreciation
  } = options
  const {
    valuationDate,
    buildingConstructionDate,
    size
  } = recordOptions
  const _records = normalizeRecords(records, recordOptions)
  const _physicalDepreciationFactor = physicalDepreciationFactor / 100
  const _functionalDepreciation = functionalDepreciation / 100
  const _economicDepreciation = economicDepreciation / 100
  const _valuationDate = moment(valuationDate)
  const _buildingConstructionDate = moment(buildingConstructionDate)
  const yearDiff = ModelAssumptionsUtil._yearsDiff(
    _valuationDate,
    _buildingConstructionDate
  )

  const mappedRecords: DepreciatedRecordRow[] = _records.map(item => {
    const depreciatedCost = threeWaysMulti(
      item.total_cost,
      _physicalDepreciationFactor,
      _functionalDepreciation,
      _economicDepreciation
    )
    return {
      ...item,
      depreciated_cost: depreciatedCost,
      depreciated_per_unit: size && size !== 0 ? depreciatedCost / size : 0
    }
  })

  const totalCost = mappedRecords.reduce(
    (acc, item) => {
      if (item.kind === 'header') return acc
      if (item.is_removed) return acc
      return acc + item.total_cost
    },
    0
  )

  const totalDepreciatedCost = mappedRecords.reduce(
    (acc, item) => {
      if (item.kind === 'header') return acc
      if (item.is_removed) return acc
      return acc + item.depreciated_cost
    },
    0
  )

  return {
    records: mappedRecords,
    graphValues: [],
    totalCost,
    totalDepreciatedCost,
    yearDiff
  }
}

export function threeWaysMulti(
  totalCost: number,
  physicalDepreciationFactor: number,
  functionalDepreciation: number,
  economicDepreciation: number
) {
  const totalDepreciation = (1 - physicalDepreciationFactor) * (1 - functionalDepreciation) * (1 - economicDepreciation)
  return totalCost * totalDepreciation
}